import React from "react";

const PackConstantWeight = (props) => {
  const { item, currentWeights } = props;

  const weight = currentWeights[item].length
    ? currentWeights[item][0]
    : currentWeights[item];

  // v2 weight.description.text
  //   "description":{
  //   	"type": "description", // description || sugestion || offer, ((sugestion não aparece no resumo e em email))
  //   	"text": "texto"
  //   },
  // description: "text"  is deprecated
  return (
    <li className={"ic-" + item} key={item}>
      <p className="detail-title">{weight.title}</p>
      {weight.description?.text && (
        <p
          className="detail-desc"
          dangerouslySetInnerHTML={{ __html: weight.description.text }}
        />
      )}
    </li>
  );
};

export default PackConstantWeight;
